module.exports = __webpack_public_path__ + "static/media/20.87f9930f.jpg";